import React from 'react';
import { Modal, Box, Flex, Text, Button } from '@mantine/core';
import { AlertCircle as AlertCircleIcon, CheckCircle } from 'lucide-react';
import { IValidateTicketResponse } from '../../../api/event';

interface ScannedResultModalProps {
    isPaused: boolean;
    validatedResult: IValidateTicketResponse | undefined;
    scannedError: string | undefined | string[];
    confirmScannedResult: () => void;
    t: (key: string) => string;
}

const ScannedResultModal: React.FC<ScannedResultModalProps> = ({
    isPaused,
    validatedResult,
    scannedError,
    confirmScannedResult,
    t
}) => {
    return (
        <Modal
            opened={Boolean(isPaused && (validatedResult || scannedError))}
            onClose={confirmScannedResult}
            centered={true}
        >
            <Box>
                {scannedError && (
                    <Flex align={"center"} direction={"column"}>
                        <AlertCircleIcon color="red" size={100} />
                        <Text mt={10} c="red" ml={10}>{scannedError}</Text>
                    </Flex>
                )}

                {validatedResult && (
                    <>
                        <Flex justify={"center"}>
                            <CheckCircle color="#099268" size={100} />
                        </Flex>

                        <Box mt={10}>
                            <Text size="sm" mb="xs" fw={500}>
                                <span>
                                    {validatedResult.key.split(':')[0]}
                                    <span className="ticket-slash-spacing">/</span>
                                    {t("seatValidate.columns.row")} {validatedResult.key.split(':')[1]}
                                    <span className="ticket-slash-spacing">/</span>
                                    {t("seatValidate.columns.seat")} {validatedResult.key.split(':')[2]}
                                </span>
                            </Text>
                            <Text size="sm" mb="xs" fw={500}>
                                {t("seatValidate.columns.price")} {validatedResult.amount}
                            </Text>
                        </Box>
                    </>
                )}
            </Box>

            <Button
                w="100%"
                mt={15}
                size="lg"
                color={validatedResult ? "#099268" : "red"}
                onClick={confirmScannedResult}
            >
                {t("common.confirmation")}
            </Button>
        </Modal>
    );
};

export default ScannedResultModal;
